import React from "react";
import styles from "./styles.module.scss";

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number;
  className?: string;
}

// Esqueleto com a forma do conteúdo final (evite spinners em cards).
const Skeleton: React.FC<SkeletonProps> = ({
  width = "100%",
  height = 12,
  radius = 6,
  className,
}) => (
  <span
    aria-hidden="true"
    className={`${styles.skeleton} ${className ?? ""}`}
    style={{ width, height, borderRadius: radius }}
  />
);

export default Skeleton;
